import React from "react";
import { Box, MenuItem, TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  filter: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.secondary
  }
}));

const PoliciesFilters = ({
  packageFilterValue,
  packageFilterOptions,
  onFilterPackage
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      width={{ xs: "100%", sm: "50%" }}
      mt={3}
      mb={2}
      maxWidth={400}
    >
      <TextField
        select
        value={packageFilterValue}
        onChange={({ target: { value } }) => onFilterPackage(value)}
        variant="filled"
        InputProps={{
          disableUnderline: true,
          inputProps: { "data-qa": "content-package-filter" }
        }}
        fullWidth
        SelectProps={{
          className: classes.filter,
          displayEmpty: true,
          renderValue: value => {
            const manualName = value
              ? packageFilterOptions.find(option => {
                  return option.id === value;
                })?.name
              : null;
            return manualName
              ? t("learningCenterLibrary.manualFilterLabel", {
                  name: manualName
                })
              : t("learningCenterLibrary.manualFilterAll", {
                  count: packageFilterOptions.length
                });
          }
        }}
        hiddenLabel
      >
        <MenuItem value="" key="all">
          {t("learningCenterLibrary.manualFilterAll", {
            count: packageFilterOptions.length
          })}
        </MenuItem>
        {!!packageFilterOptions &&
          packageFilterOptions.map(option => {
            return (
              <MenuItem value={option.id} key={option.id}>
                {option.name}
              </MenuItem>
            );
          })}
      </TextField>
    </Box>
  );
};

export default PoliciesFilters;

PoliciesFilters.propTypes = {
  packageFilterValue: PropTypes.string,
  packageFilterOptions: PropTypes.array,
  onFilterPackage: PropTypes.func
};
